import { render, staticRenderFns } from "./genderAgeChart.vue?vue&type=template&id=3cf3fd74"
import script from "./genderAgeChart.vue?vue&type=script&lang=js"
export * from "./genderAgeChart.vue?vue&type=script&lang=js"
import style0 from "./genderAgeChart.vue?vue&type=style&index=0&id=3cf3fd74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports